import createLucideIcon from '../createLucideIcon';

const LineChart = createLucideIcon('LineChartIcon', [
  ['path', { d: 'M3 3v18h18', key: '1s2lah' }],
  ['path', { d: 'm19 9-5 5-4-4-3 3', key: '2osh9i' }],
]);

export default LineChart;
